import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import ProductListingSEOLinkedData from './ProductListingSEOLinkedData';
const ProductListingPageTitleAndMetaTags = t0 => {
  const $ = _c(10);
  const {
    serverOwnsSeoTags: t1
  } = t0;
  const serverOwnsSeoTags = t1 === undefined ? false : t1;
  const {
    loading,
    pageHtmlTitle: t2,
    pageMetaDescription: t3,
    pageName: t4
  } = useProductListingPageContext();
  const pageHtmlTitle = t2 === undefined ? "" : t2;
  const pageMetaDescription = t3 === undefined ? "" : t3;
  const pageName = t4 === undefined ? "" : t4;
  let t5;
  if ($[0] !== pageHtmlTitle || $[1] !== pageMetaDescription || $[2] !== pageName || $[3] !== serverOwnsSeoTags) {
    t5 = !serverOwnsSeoTags && <Helmet><title>{pageHtmlTitle}</title>{pageMetaDescription && <meta name="description" content={pageMetaDescription} />}<meta property="og:type" content="category" />{pageName && <meta property="og:title" content={pageName} />}{pageMetaDescription && <meta property="og:description" content={pageMetaDescription} />}</Helmet>;
    $[0] = pageHtmlTitle;
    $[1] = pageMetaDescription;
    $[2] = pageName;
    $[3] = serverOwnsSeoTags;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== loading) {
    t6 = !loading && <ProductListingSEOLinkedData />;
    $[5] = loading;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
ProductListingPageTitleAndMetaTags.propTypes = {
  serverOwnsSeoTags: PropTypes.bool
};
export default ProductListingPageTitleAndMetaTags;